import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ProductItem from './ProductItem';
import { Heading } from '../StyledComponents';
import ProductsContainer from './ProductsContainer';

import './Products.module.scss';

class Products extends React.PureComponent {
  renderProductsRow(indices) {
    const {
      isMobile,
      designSettings,
    } = this.props;

    return (
      <ProductsContainer key={indices.join('')} isMobile={isMobile}>
        { indices.map(index => (
            <ProductItem
              key={index}
              isMobile={isMobile}
              designSettings={designSettings}
              { ...getProductProps(this.props, index) }
            />
          )
        )}
      </ProductsContainer>
    );
  }

  render() {
    const {
      isMobile,
      title,
      designSettings: {
        bodyHeadingsColor,
        headingFontSize,
        headingFont,
      },
    } = this.props;

    const layout = isMobile ? [[0, 1], [2, 3]] : [[0, 1, 2, 3]];

    return (
      <div styleName={classNames('products', { mobile: isMobile })}>
        <div styleName="title">
          <Heading
            type="headingPrimary"
            isMobile={isMobile}
            fontSize={headingFontSize}
            font={headingFont}
            color={bodyHeadingsColor}
          >
            {title}
          </Heading>
        </div>
        <div styleName="product-rows">
         { layout.map(indices => this.renderProductsRow(indices)) }
        </div>
      </div>
    );
  }
}

function getProductProps(props, index) {
  const prefix = 'product' + (index + 1);

  return {
    name: props[`${prefix}Name`],
    price: props[`${prefix}Price`],
    link: props[`${prefix}Link`],
    imageUrl: props[`${prefix}ImageUrl`],
    mobileImageUrl: props[`${prefix}MobileImageUrl`],
  };
}

Products.propTypes = {
  isMobile: PropTypes.bool,
  title: PropTypes.string,
};

export default Products;


// WEBPACK FOOTER //
// ./src/js/widgets/Products/Products.js